import React, { Component, Fragment } from 'react';
import Grid from '../../../Utils/Grid/index';
import { TableHeaderColumn } from "react-bootstrap-table";
import {RenderMoneda} from "../../../Utils/renderField/renderTableField";


export default class GridMasVendidos extends Component {

    render() {
        const { loader, data, page, listar, onPageChange, onSortChange} = this.props;

        return (
            <Fragment>
                <Grid
                    hover
                    striped
                    data={data}
                    loading={loader}
                    page={page}
                    className="reporte-table"
                    onPageChange={listar} onSortChange={onSortChange}
                >
                    <TableHeaderColumn
                        isKey
                        dataField="detalle__producto__id"
                        dataSort
                        className='reporte-table'
                        dataFormat={(cell)=>(
                                cell ? '' : ''
                            )
                        }
                        width="10%"
                    />
                    <TableHeaderColumn
                        dataField="detalle__producto__nombre"
                        dataSort
                        className='reporte-table'
                        dataFormat={(cell, row) => (
                            cell ? cell : "Sin registro"
                        )}
                    >
                        PRODUCTO
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="detalle__producto__codigo"
                        dataSort
                        className='reporte-table'
                        dataFormat={(cell) => cell ? cell : "Sin registro"}
                    >
                        CODIGO
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="detalle__producto__tipo_producto__nombre"
                        dataSort
                        className='reporte-table'
                        dataFormat={(cell) => ( cell ? cell : "Sin registro")}
                    >
                        TIPO PRODUCTO
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="total_cantidad"
                        dataSort
                        className='reporte-table'
                        dataFormat={(cell) => ( cell  || cell == 0 ? <RenderMoneda simbolo={" "} monto={cell}/> : "Sin registro" )}
                    >
                        CANTIDAD
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="total_real"
                        dataSort
                        className='reporte-table'
                        dataFormat={(cell) => ( cell  || cell == 0 ? <RenderMoneda monto={cell}/> : "Sin registro" )}
                        TOTAL
                    >
                    </TableHeaderColumn>
                </Grid>
            </Fragment>
        )
    }

}
